import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-create-activity-dialog',
  templateUrl: './create-activity-dialog.component.html',
  styleUrls: ['./create-activity-dialog.component.scss']
})
export class CreateActivityDialogComponent implements OnInit {
  pageTitle: string;

  constructor() {
    this.pageTitle = 'Δημιουργία νέας δήλωσης';
  }

  ngOnInit(): void {
  }

}
